import { useEffect, useMemo, useState } from 'react';
import './styles.scss';
import { updateUserProfile } from 'services/profile.service';
import { useAuth } from 'context/AuthContext';
import { IoIosClose } from 'react-icons/io';
import { useLocation } from 'react-router';
import { getHelp } from 'services/tutorial.service';
import { useModal } from 'context/ModalContext';
import { useHelp } from 'context/HelpContext';

const modalId = 'help-video';

export default function VideoHelp() {
  const { user, refreshUser } = useAuth();
  const location = useLocation();

  const { openModal, closeModal, showModal } = useModal();
  const { setDataHelp } = useHelp();

  const [modalData, setModalData] = useState<any>([]);
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(true);

  async function handleCloseTutorial() {
    setData(null);
    closeModal();
  }

  const hasHelp = useMemo(() => {
    if (!modalData?.length) return;

    const hasItem = modalData?.find((item: any) => {
      if (item.location === location.pathname) return true;

      const _item = item.location.split('/');
      const _location = location.pathname.split('/');

      if (_item.length !== _location.length) return false;

      return _item[1] === _location[1];
    });

    setDataHelp(hasItem)
    return hasItem;
  }, [location.pathname, modalData, setDataHelp]);

  useEffect(() => {
    if(!openModal || openModal !== modalId || !modalData?.length) return;

    if (hasHelp) {
      setData(hasHelp);

      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal, modalData, user]);

  useEffect(() => {
    if (!user) return;
    async function loadHelp() {
      const data = await getHelp();

      if (data) {
        setModalData(data);
      }
    }

    loadHelp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!data) return null;

  return (
    <div className="z-50 modal-news rb-modal-overlay rb-modal-overlay--top">
      <div
        className="relative rounded-lg p-10 w-[60%] max-h-[70vh] h-auto flex flex-col"
        style={{
          background: '#fff',
          color: 'var(--color-text-body)',
          border: '1px solid var(--color-border-light)',
          boxShadow: '0 24px 60px rgba(2, 12, 40, 0.4)',
        }}
      >
        <button className="rb-modal__close" aria-label="Fechar" onClick={() => handleCloseTutorial()}>
          <IoIosClose size={26} />
        </button>

        {data?.title && !loading && <div className="mb-5" dangerouslySetInnerHTML={{ __html: data.title }}></div>}

        <div className={`flex-1 ${loading ? 'hidden' : ''}`}>
          <iframe src={data?.url} width="100%" height="100%" allowFullScreen title="Tutorial"></iframe>
        </div>

        {loading && <div className="flex-1 flex justify-center items-center">Carregando...</div>}
      </div>
    </div>
  );
}
